'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 40px 0;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;

  width: 100%;
  max-width: 1720px;
  gap: 72px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  padding: 10%;
  gap: 128px;

  background: ${colors.linearBlue};
  box-shadow: 0 14px 16px rgba(0, 0, 0, 0.1);

  color: ${colors.light};
  border-radius: 22px;

  @media (max-width: 1720px) {
    border-radius: 0;
  }

  @media (max-width: ${breakpoints.largeDesktop}) {
    padding: 10% 5% 5%;
    gap: 64px;
  }

  @media (max-width: ${breakpoints.laptop}) {
    padding-top: 96px;
  }
`;

export const ColumnWrap = styled.div`
  display: flex;
  justify-content: space-between;

  gap: 5%;

  @media (max-width: ${breakpoints.largeDesktop}) {
    gap: 40px;
  }

  @media (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: ${breakpoints.largeDesktop}) {
    gap: 40px;
  }
`;

export const Title = styled.div`
  font-size: 3.5rem;
  font-weight: 700;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 3rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.div`
  margin-top: 6px;

  font-size: 1rem;
  color: ${({ $darker }) => ($darker ? 'rgba(255, 255, 255, 0.51)' : colors.silver)};

  ${({ $flex }) => $flex && 'display: flex; align-items: center; gap: 8px;'}

  & > a {
    font-weight: 700;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 12px;

    font-size: 0.9rem;
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: 20px;
  margin-bottom: 20px;
  gap: 20px;
`;

export const Links = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  gap: 32px;

  font-size: 1.2rem;
`;

export const LinksColumn = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1.6rem;
  width: fit-content;
  padding: 0 48px;

  & > * {
    text-align: center;
    transition: 0.3s all ease;
    &:hover {
      transform: translateX(4px);
    }
  }
`;

export const Copyright = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  font-size: 14px;
  letter-spacing: 1px;
  gap: 16px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const SocialIconsWrap = styled.div`
  position: absolute;
  top: 32px;
  left: 0;

  width: 100%;
  padding: 0 10%;

  @media (max-width: ${breakpoints.largeDesktop}) {
    padding: 0 5%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
    justify-content: center;
    padding: 0;
  }
`;

export const ContactMediums = styled.div`
  display: flex;

  gap: 60px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;

    gap: 8px;
  }
`;
